import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer>
      <p>© 2024 <Link to="/">NorZah Educate</Link>. All Rights Reserved</p>
    </footer>
  )
}